var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "254.5px",
    height: "200px",
    viewBox: "0 0 254.5 200",
    style: {
      enableBackground: "new 0 0 254.5 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "path1_fill",
    d: "M254.4,98.1c-0.1-0.3-0.2-0.6-0.3-0.8c-0.1-0.3-0.2-0.6-0.3-1c-0.1-0.3-0.3-0.6-0.5-1 c-0.1-0.2-0.2-0.5-0.4-0.7c-0.4-0.5-0.8-1-1.2-1.5L161,2.8c-3.8-3.8-9.9-3.8-13.7,0c-3.8,3.8-3.8,9.9,0,13.7l74.1,73.8H9.7 C4.3,90.3,0,94.7,0,100c0,5.3,4.3,9.7,9.7,9.7h211.7l-74.1,73.8c-3.8,3.8-3.8,9.9,0,13.7c1.9,1.9,4.4,2.8,6.9,2.8 c2.5,0,5-0.9,6.9-2.8l90.7-90.3c0.5-0.4,0.9-1,1.2-1.5c0.2-0.2,0.3-0.5,0.4-0.7c0.2-0.3,0.4-0.6,0.5-1c0.1-0.3,0.2-0.6,0.3-1 c0.1-0.3,0.2-0.6,0.3-0.8C254.6,100.6,254.6,99.4,254.4,98.1z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.ea387ff5.svg";
export { ForwardRef as ReactComponent };